module.exports = __webpack_public_path__ + "static/media/CeraPro-Black.eb9b1117.eot";